import { useCallback, useEffect, useState } from "react";

import type { OrganizationEstimate, Organization } from "@packages/client";

export const useOrganizationEstimate = (organization: Organization) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<OrganizationEstimate>();

  const load = useCallback(async () => {
    setIsLoading(true);

    const response = await organization.getEstimate({
      simulate_discount: "allowance"
    });

    setData(response);
    setIsLoading(false);
  }, [organization]);

  useEffect(() => {
    if (!data) load();
  }, [load, data]);

  return { data, load, isLoading };
};
